import React, { useState, useEffect } from "react";
import { getFirestore, collection, getDocs, query, orderBy, updateDoc, doc, deleteDoc } from "firebase/firestore";

import { Button, Card } from "react-bootstrap";

const ViewScholarships = () => {
    const [scholarships, setScholarships] = useState([]);
    const [expiredScholarships, setExpiredScholarships] = useState([]);

    useEffect(() => {
        fetchScholarships();
    }, []);

    const fetchScholarships = async () => {
        try {
            const firestoreDb = getFirestore();
            const scholarshipsRef = collection(firestoreDb, "Scholarship");
            const q = query(scholarshipsRef, orderBy("deadline"));
            const querySnapshot = await getDocs(q);
            const scholarshipList = [];
            const expiredList = [];
            const currentDate = new Date();
            querySnapshot.forEach((doc) => {
                const scholarship = { id: doc.id, ...doc.data() };
                scholarshipList.push(scholarship);
                if (scholarship.deadline < currentDate) {
                    expiredList.push(scholarship);
                }
            });
            setScholarships(scholarshipList);
            setExpiredScholarships(expiredList);
        } catch (error) {
            console.error("Error fetching scholarships: ", error);
        }
    };

    const markAsExpired = async (id) => {
        try {
            const firestoreDb = getFirestore();
            const scholarshipRef = doc(firestoreDb, "Scholarship", id);

            // Update the scholarship document to mark it as expired
            await updateDoc(scholarshipRef, {
                expired: true,
            });

            // Delete the expired scholarship from the collection
            await deleteDoc(scholarshipRef);

            // Refresh scholarships after marking one as expired and removing it
            fetchScholarships();
        } catch (error) {
            console.error("Error marking scholarship as expired: ", error);
        }
    };
    console.log(markAsExpired)
    return (
        <div className="container mt-5">
            <h2 style={{marginLeft:"40%"}}>Current Scholarships </h2>
            <div className="row">
                {scholarships.map((scholarship) => (
                    <div className="col-md-4 mb-4" key={scholarship.id}>
                        <Card>
                            <Card.Body>
                                <Card.Title>{scholarship.title}</Card.Title>
                                <Card.Text>
                                    <strong>Deadline:</strong> {scholarship.deadline}
                                </Card.Text>
                                {!scholarship.expired && (
                                    <Button onClick={() => markAsExpired(scholarship.id)} variant="outline-danger" size="sm">
                                        Expire
                                    </Button>
                                )}
                            </Card.Body>
                        </Card>
                    </div>
                ))}
            </div>
            {expiredScholarships.length > 0 && (
                <div className="mt-5">
                    <h2 style={{marginLeft:"40%"}}>Expired Scholarships</h2>
                    <div className="row">
                        {expiredScholarships.map((scholarship) => (
                            <div className="col-md-4 mb-4" key={scholarship.id}>
                                <Card>
                                    <Card.Body>
                                        <Card.Title>{scholarship.title}</Card.Title>
                                        <Card.Text>
                                            <strong>Deadline:</strong> {scholarship.deadline}
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </div>
                        ))}
                    </div>
                </div>
            )}

        </div>
    );
};

export default ViewScholarships;
